import './Projects.css';
import ProjectCard from '../cards/ProjectCard';

function Projects() {
    return (
        <section className='projects' id='projects'>
            <hgroup>
                <h2>My Projects</h2>
                <p>What I've been Working On</p>
            </hgroup>

            <div className='flex-wrapper'>
            <ProjectCard
                    title='Fracture Magazine'
                    description="I recently worked with some friends to get their magazine site setup. Check it out!"
                    live="https://www.fracturemagazine.com"
                />
                <ProjectCard
                    title='pulltarot.cards'
                    description='Vanilla JS App that allows users to pull 3 Tarot cards and prompts
                                user to reflect on what those cards might mean to them.'
                    live='https://pulltarot.cards'
                />
            </div>
        </section>
    );
}

export default Projects;